<template>
    <section class="col-12 content-full">
        <a class="block block-rounded block-link-pop">
            <div class="block-header block-header-default">
                <h3 class="block-title">
                    SMS - Sender Codes
                </h3>
            </div>
            <div class="block-content">
                <v-server-table theme="bootstrap4" :columns="columns" :options="options">
                    <div slot="action" slot-scope="props">
                        <div class="dropdown">
                            <button type="button" class="btn btn-sm btn-outline-primary" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                <i class="si si-settings"></i> Options
                            </button>
                            <div class="dropdown-menu dropdown-menu-right"
                                 aria-labelledby="dropdown-align-outline-primary" x-placement="bottom-end"
                                 style="position: absolute; transform: translate3d(-68px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                                <a class="dropdown-item" href="javascript:void(0)">Action</a>
                                <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                                <div class="dropdown-divider"></div>
                                <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            </div>
                        </div>
                    </div>
                </v-server-table>
            </div>
        </a>
    </section>

</template>

<script>
    import {APP_CONFIG} from "../../config";


    export default {
        name: "SenderCodes",
        data() {
            return {
                columns: [
                    'serviceName',
                    'senderName',
                    'cost',
                    'created_at',
                    'productType',
                    'status',
                    'created_at'
                ],
                options: {
                    requestFunction: function (data) {
                        return axios.get(APP_CONFIG.URL + `web/projects/${this.$route.params.project}/sms/sender-codes`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    },
                    pagination: {
                        chunk: 5,
                        nav: "scroll",
                        edge: true
                    },
                    dateColumns:['created_at']
                }
            }
        }
    }
</script>

<style scoped>

</style>
